"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _async = _interopRequireDefault(require("react-select/async"));

var _peractoConfig = require("@peracto/peracto-config");

var _TextInput = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/TextInput"));

var _Select = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Select"));

var _Slider = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/Slider"));

var _File = _interopRequireDefault(require("@peracto/peracto-editor-ui/dist/File"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _debouncePromise = _interopRequireDefault(require("debounce-promise"));

var _axios = _interopRequireDefault(require("axios"));

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTrash = require("@fortawesome/pro-regular-svg-icons/faTrash");

var _faPlusCircle = require("@fortawesome/pro-regular-svg-icons/faPlusCircle");

var _faSave = require("@fortawesome/pro-regular-svg-icons/faSave");

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _regeneratorRuntime() {
  "use strict";
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

  _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  };

  var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }

  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
    return generator._invoke = function (innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");

        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }

        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);

          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }

          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }(innerFn, self, context), generator;
  }

  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }

  exports.wrap = wrap;
  var ContinueSentinel = {};

  function Generator() {}

  function GeneratorFunction() {}

  function GeneratorFunctionPrototype() {}

  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);

      if ("throw" !== record.type) {
        var result = record.arg,
            value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }

      reject(record.arg);
    }

    var previousPromise;

    this._invoke = function (method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    };
  }

  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];

    if (undefined === method) {
      if (context.delegate = null, "throw" === context.method) {
        if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
        context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }

  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }

  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          for (; ++i < iterable.length;) {
            if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
          }

          return next.value = undefined, next.done = !0, next;
        };

        return next.next = next;
      }
    }

    return {
      next: doneResult
    };
  }

  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }

  return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (object) {
    var keys = [];

    for (var key in object) {
      keys.push(key);
    }

    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }

      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
        "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      }
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;

      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
            record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];

        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;

          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }

          return thrown;
        }
      }

      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var DEFAULT_ATTRIBUTE = {
  attribute: '',
  value: '',
  label: 'Please select...'
};

var AttributeDivider = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    height: 30px;\n    position: relative;\n    text-align: center;\n    text-transform: uppercase;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    &:before {\n        display: inline-block;\n        content: ", ";\n        background-color: ", ";\n        padding-left: 10px;\n        padding-right: 10px;\n        z-index: 1;\n    }\n\n    &:after {\n        content: '';\n        position: absolute;\n        left: 0;\n        right: 0;\n        height: 1px;\n        background-color: ", ";\n    }\n"])), function (props) {
  return props.attributeOperator ? "'".concat(props.attributeOperator, "'") : '';
}, function (props) {
  return props.theme.admin.colors.brandDark;
}, function (props) {
  return props.theme.admin.colors.greyLight;
});

var ProductsForm = function ProductsForm(_ref) {
  var _theme$colors;

  var _onChange = _ref.onChange,
      state = _ref.state;
  var _state$numberOfProduc = state.numberOfProducts,
      numberOfProducts = _state$numberOfProduc === void 0 ? 4 : _state$numberOfProduc,
      _state$attributes = state.attributes,
      attributes = _state$attributes === void 0 ? [_objectSpread({}, DEFAULT_ATTRIBUTE)] : _state$attributes,
      _state$attributeOpera = state.attributeOperator,
      attributeOperator = _state$attributeOpera === void 0 ? 'and' : _state$attributeOpera,
      _state$hitsDirection = state.hitsDirection,
      hitsDirection = _state$hitsDirection === void 0 ? 'row' : _state$hitsDirection,
      _state$hitsAlignment = state.hitsAlignment,
      hitsAlignment = _state$hitsAlignment === void 0 ? 'flex-start' : _state$hitsAlignment,
      _state$productCardDir = state.productCardDirection,
      productCardDirection = _state$productCardDir === void 0 ? 'column' : _state$productCardDir,
      _state$fontColour = state.fontColour,
      fontColour = _state$fontColour === void 0 ? '#000' : _state$fontColour,
      _state$fontFamily = state.fontFamily,
      fontFamily = _state$fontFamily === void 0 ? 'body' : _state$fontFamily,
      _state$fallbackImage = state.fallbackImage,
      fallbackImage = _state$fallbackImage === void 0 ? '' : _state$fallbackImage;

  var _useState = (0, _react.useState)(attributes),
      _useState2 = _slicedToArray(_useState, 2),
      localAttributes = _useState2[0],
      setLocalAttributes = _useState2[1];

  var config = (0, _peractoConfig.useConfig)();
  var API_URL = config.get('api');

  var _ref2 = config.get('editorConfig') || [],
      theme = _ref2.theme;

  var themeColours = [];

  if (theme !== null && theme !== void 0 && (_theme$colors = theme.colors) !== null && _theme$colors !== void 0 && _theme$colors.brand) {
    for (var _i2 = 0, _Object$entries = Object.entries(theme.colors.brand); _i2 < _Object$entries.length; _i2++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
          label = _Object$entries$_i[0],
          colour = _Object$entries$_i[1];

      themeColours.push({
        label: (0, _startCase["default"])(label),
        value: colour
      });
    }
  }

  var themeFonts = [];

  if (theme !== null && theme !== void 0 && theme.fonts) {
    Object.keys(theme.fonts).map(function (font) {
      return themeFonts.push({
        label: (0, _startCase["default"])(font),
        value: font
      });
    });
  }

  var fetchAttributes = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(input) {
      var _yield$axios$get, data, parsedData, values;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _axios["default"].get("".concat(API_URL, "/attributes?label=").concat(input || '', "&filterable=true"), {
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: "Bearer ".concat(localStorage.getItem('token'))
                }
              });

            case 2:
              _yield$axios$get = _context.sent;
              data = _yield$axios$get.data;
              parsedData = data['hydra:member'];
              values = parsedData.map(function (form) {
                return {
                  label: form.label,
                  value: form.code
                };
              });
              return _context.abrupt("return", [{
                label: 'SKU',
                value: 'sku'
              }].concat(_toConsumableArray(values)));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAttributes(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  var debouncedFetchAttributes = (0, _debouncePromise["default"])(fetchAttributes, 200);
  var alignmentOptions = [{
    label: 'Start',
    value: 'flex-start'
  }, {
    label: 'Centre',
    value: 'center'
  }, {
    label: 'End',
    value: 'flex-end'
  }];

  if (hitsDirection === 'row') {
    alignmentOptions = [].concat(_toConsumableArray(alignmentOptions), [{
      label: 'Space Around',
      value: 'space-around'
    }, {
      label: 'Space Between',
      value: 'space-between'
    }]);
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group mb-0"
  }, /*#__PURE__*/_react["default"].createElement("h6", null, "Attributes"), localAttributes.map(function (attr, idx) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: "attributes_".concat(attr.label, "_").concat(idx)
    }, idx > 0 && /*#__PURE__*/_react["default"].createElement(AttributeDivider, {
      attributeOperator: attributeOperator
    }), /*#__PURE__*/_react["default"].createElement("label", {
      className: "mb-1"
    }, "Attribute Name"), /*#__PURE__*/_react["default"].createElement(_async["default"], {
      className: "w-100 mb-2",
      loadOptions: function loadOptions(input) {
        return debouncedFetchAttributes(input);
      },
      isSearchable: true,
      defaultOptions: true,
      value: {
        label: attr.label,
        value: attr.attribute
      },
      onChange: function onChange(option) {
        var attrs = _toConsumableArray(localAttributes);

        attrs[idx].attribute = option.value;
        attrs[idx].label = option.label;
        setLocalAttributes(_toConsumableArray(attrs));
      },
      placeholder: "Select an attribute...",
      classNamePrefix: "peracto-select",
      noOptionsMessage: function noOptionsMessage(_ref4) {
        var inputValue = _ref4.inputValue;

        if (inputValue.length > 0) {
          return "No attributes found for '".concat(inputValue, "'.");
        } else {
          return 'Enter text to begin searching.';
        }
      }
    }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
      label: "Attribute Value",
      onChange: function onChange(e) {
        var attrs = _toConsumableArray(localAttributes);

        attrs[idx].value = e.target.value;
        setLocalAttributes(_toConsumableArray(attrs));
      },
      value: localAttributes[idx].value
    }), idx > 0 && /*#__PURE__*/_react["default"].createElement("button", {
      className: "btn btn-sm btn-danger w-100 my-2",
      onClick: function onClick(e) {
        var attrs = _toConsumableArray(localAttributes);

        attrs.splice(idx, 1);
        setLocalAttributes(_toConsumableArray(attrs));
      }
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: _faTrash.faTrash,
      className: "mr-2"
    }), " Remove Attribute"));
  })), /*#__PURE__*/_react["default"].createElement(AttributeDivider, null), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-secondary w-100 my-2",
    onClick: function onClick(e) {
      var attrs = [].concat(_toConsumableArray(localAttributes), [_objectSpread({}, DEFAULT_ATTRIBUTE)]);
      setLocalAttributes(attrs);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faPlusCircle.faPlusCircle,
    className: "mr-2"
  }), " Add Attribute"), /*#__PURE__*/_react["default"].createElement("hr", null), /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-success w-100 my-2",
    onClick: function onClick(e) {
      _onChange({
        attributes: localAttributes
      });
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faSave.faSave,
    className: "mr-2"
  }), " Save Attributes"), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Attribute Operator",
    options: [{
      label: 'And',
      value: 'and'
    }, {
      label: 'Or',
      value: 'or'
    }],
    value: attributeOperator,
    onChange: function onChange(e) {
      return _onChange({
        attributeOperator: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    label: "Number of Products: ".concat(numberOfProducts),
    min: 1,
    max: 6,
    step: 1,
    value: numberOfProducts,
    onChange: function onChange(e) {
      return _onChange({
        numberOfProducts: e.target.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_File["default"], {
    label: "Fallback Image",
    onChange: function onChange(value) {
      return _onChange({
        fallbackImage: value
      });
    },
    value: fallbackImage,
    isInline: false
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Results Direction",
    options: [{
      label: 'Row',
      value: 'row'
    }, {
      label: 'Column',
      value: 'column'
    }],
    value: hitsDirection,
    onChange: function onChange(e) {
      return _onChange({
        hitsDirection: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Results Alignment",
    options: alignmentOptions,
    value: hitsAlignment,
    onChange: function onChange(e) {
      return _onChange({
        hitsAlignment: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Product Card Direction",
    options: [{
      label: 'Stack',
      value: 'column'
    }, {
      label: 'Inline',
      value: 'row'
    }],
    value: productCardDirection,
    onChange: function onChange(e) {
      return _onChange({
        productCardDirection: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Font Family",
    options: themeFonts,
    value: fontFamily,
    onChange: function onChange(e) {
      return _onChange({
        fontFamily: e.value
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_Select["default"], {
    label: "Font Colour",
    options: themeColours,
    value: fontColour,
    onChange: function onChange(e) {
      return _onChange({
        fontColour: e.value
      });
    }
  }));
};

var _default = ProductsForm;
exports["default"] = _default;